import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { DetailList } from '#components/patterns/detail-list/DetailList.tsx';
import { DetailListRow } from '#components/patterns/detail-list/DetailListRow.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { AccountDeletion } from '#screens/settings/user/delete/AccountDeletion.tsx';

/**
 * {@link OrganizationSection} shows the organization's name, which appears in invite emails and Nebula
 * clients, with a link to rename it and the control to delete it.
 */
export function OrganizationSection() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <DetailCard>
      <h2 className="h4 mt-0 mb-8">Organization</h2>
      <p className="p-md mb-8">The name appears in invite emails and Nebula clients.</p>
      <DetailList className="mb-16">
        <DetailListRow
          label="Name"
          value={
            <div className="flex flex-wrap align-center gap-8">
              {user.organization.name}
              <Link to="organization/rename" className="a">
                Rename
              </Link>
            </div>
          }
        />
      </DetailList>
      <AccountDeletion />
    </DetailCard>
  );
}
